<div class="grid-container grid-1">
    @if (isMonoBuilding$ | async) {
        <p class="dividers sse-titles-color">{{ 'DIVIDERS.MY_FAV_SENSORS' | translate }}</p>
    }
    @if (!(isMonoBuilding$ | async)) {
        <p class="dividers sse-titles-color">{{ 'DIVIDERS.ALL_SENSORS' | translate }}</p>
    }
    @if (!(loading$ | async) && (sensorsUniverses$ | async)?.length) {
        <div class="grid-container grid-4 grid-3-medium-screens grid-2-small-screens">
            <!--  SC-22282 : Temporarily (or not) disabled -->
            <!-- @if ((building$ | async)?.city && (isMonoBuilding$ | async)) {
                <weather-today class="weather-today-only height-100" [building]="building$ | async"></weather-today>
            } -->

            @for (sensor of sensorsUniverses$ | async; track sensor) {
                <sensor-info [sensors]="sensor.sensors" [universeId]="sensor.universeId" />
            }
        </div>
    } @else {
        <loading-and-error
            [isLoading]="loading$ | async"
            [hasNoData]="!(sensorsUniverses$ | async)?.length"
            [noDataMessage]="'BUILDING_HOME.NO_FAVORITE_SENSORS' | translate"
        />
    }
</div>
